import { Modal } from "antd";
import { useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
interface IProps {
  src: string;
}
const ModalVideo = (props: IProps) => {
  const { src } = props;
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
        }}
      >
        <video
          src={src}
          preload="metadata"
          height={"100%"}
          width={"100%"}
          controls={false}
          autoPlay={false}
          loop={false}
          onClick={() => {
            setIsOpen(true);
          }}
        />

        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            top: 0,
            cursor: "pointer",
          }}
          onClick={() => {
            setIsOpen(true);
          }}
        ></div>
      </div>
      <Modal
        destroyOnClose
        open={isOpen}
        width={"calc(100vw - 180px)"}
        footer={null}
        onCancel={() => setIsOpen(false)}
        closeIcon={
          <div
            style={{
              background: "red",
              position: "relative",
            }}
          >
            <div
              style={{
                position: "absolute",
                right: 1,
                top: -15,
              }}
            >
              <CloseOutlined />
            </div>
          </div>
        }
        style={{
          display: "flex",
          justifyContent: "center",
          maxHeight: "100vh",
        }}
      >
        <video
          src={src}
          autoPlay
          controls
          width={"100%"}
          style={{
            maxHeight: "calc(100vh - 180px)",
            maxWidth: "calc(100vw - 180px)",
          }}
          controlsList="nodownload"
        />
      </Modal>
    </>
  );
};

export default ModalVideo;
